/**
 * Created by Ning Jiang on 6/27/2019.
 */

import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";

export class PPNoWinSymbolsWinPresentationController extends NoWinSymbolsWinPresentationController {

    constructor(indexes:[number, number]) {
        super(indexes, {noWinStateFadeInDuration : 1});
    }

    protected onUpdateBetWins(wins:IBetWinData[]):void {
        this._noWinSymbols = [];
        super.onUpdateBetWins(wins);
        // no need to create new noWinSymbols here.
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        if(!this.hasWin()) {
            return;
        }

        super.parseFeatureGameData(data);
        // remove scatter symbols from this._symbolWinStates if win fs.
        if(data.freespinTriggeredThisSpin) {
            data.scatterPositions!.forEach((symId:number, reelId:number) => {
                this._symbolWinStates[reelId][symId] = true;
            });
        }
    }
}